import {
  ApplicationConfig,
  DEFAULT_CURRENCY_CODE,
  importProvidersFrom,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import dayjs from 'dayjs';
import dech from 'dayjs/locale/de-ch';
import { DateAdapter, DAYS_OF_WEEK, MOMENT, provideCalendar } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/moment';
import { CurrencyPipe, DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { ApiModule } from '@work-frontend-monorepo/work-rest-api';
import { environment } from '@work-frontend-monorepo/work-environments';
import { ApiTokenInterceptor, WorkAuthenticationModule } from '@work-frontend-monorepo/work-authentication';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideModuleTranslateLoader } from '@larscom/ngx-translate-module-loader';
import { ExceptionHandlingService } from '@work-frontend-monorepo/work-ui/services';
import { WorkStateModule } from '@work-frontend-monorepo/work-ui/state-management';

const baseTranslateUrl = './assets/i18n';

dayjs.locale({
  ...dech,
  weekStart: DAYS_OF_WEEK.MONDAY,
});

const datePipeOptionsFactory = () => {
  return {
    dateFormat: 'shortDate',
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideCalendar({
      provide: DateAdapter,
      useFactory: () => adapterFactory(dayjs),
    }),
    {
      provide: MOMENT,
      useValue: dayjs,
    },
    CurrencyPipe,
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    {
      provide: LOCALE_ID,
      useValue: 'de-CH',
    },
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useFactory: datePipeOptionsFactory,
    },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: 'CHF',
    },
    provideTranslateService({
      loader: provideModuleTranslateLoader({
        modules: [{ baseTranslateUrl }, { moduleName: 'TABLESOCCER', baseTranslateUrl }],
      }),
      fallbackLang: 'de',
      lang: 'de',
    }),
    provideRouter(appRoutes),
    ExceptionHandlingService,
    importProvidersFrom(ApiModule.forRoot({ rootUrl: environment.apiConfiguration.baseUrl }), WorkAuthenticationModule, WorkStateModule),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiTokenInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
};
